// Workaround to make bootstrap js work correctly
var $ = window.jQuery = require("./..\\..\\bower_components\\jquery\\dist\\jquery.js");
require("./..\\..\\bower_components\\bootstrap-sass\\assets\\javascripts\\bootstrap.js");
var engine = require('./engine/index');
var arrangeSidebarButtons = require('./ui/arrangeSidebarButtons');

$(document).ready(function() {
	// Init match engine
	engine.init();

	// Arrange sidebar buttons and attach event handler to resize action
	arrangeSidebarButtons();
	$(window).resize(arrangeSidebarButtons);
});
